export default __webpack_public_path__ + "static/media/noise_bg_helper.fbdb8db7.png";